import { changeQualityStatus } from "api/Customers";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";

export const useChangeQualityStatus = () => {
    const queryClient = useQueryClient();

    return useMutation(changeQualityStatus, {
        onSuccess: () => {
            toast.success('Changed Successfully')
            queryClient.invalidateQueries('quality-check-customers');

        },
        onError: (error: any) => {
            if (error.response.data.message) {
                toast.error(error.response.data.message);
                return
            }
            if (error.response.data.error) {
                toast.error(error.response.data.error);
                return
            }
            toast.error('Something went wrong')
        }
    });
};
